import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  officerGroups: [],
  selectedOfficerGroup: null,
  loading: false,
  error: null,
  successMessage: null,
  // Pagination
  page: 1,
  pageSize: 10,
  total: 0,
  // Sorting
  sortColumn: 'name',
  sortDirection: 'asc',
  // Filtering
  filterName: '',
};

const officerGroupsSlice = createSlice({
  name: 'officerGroups',
  initialState,
  reducers: {
    // Fetch officer groups
    fetchOfficerGroups: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchOfficerGroupsSuccess: (state, action) => {
      state.loading = false;
      state.officerGroups = action.payload.data;
      state.total = action.payload.meta.total;
      state.error = null;
    },
    fetchOfficerGroupsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Fetch officer group by ID
    fetchOfficerGroupById: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchOfficerGroupByIdSuccess: (state, action) => {
      state.loading = false;
      state.selectedOfficerGroup = action.payload;
      state.error = null;
    },
    fetchOfficerGroupByIdFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Add officer group
    addOfficerGroup: (state) => {
      state.loading = true;
      state.error = null;
    },
    addOfficerGroupSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    addOfficerGroupFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update officer group
    updateOfficerGroup: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateOfficerGroupSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    updateOfficerGroupFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Delete officer group
    deleteOfficerGroup: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteOfficerGroupSuccess: (state, action) => {
      state.loading = false;
      state.officerGroups = state.officerGroups.filter((og) => og.id !== action.payload);
      state.error = null;
      state.successMessage = action.payload.message;
    },
    deleteOfficerGroupFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Bulk delete
    bulkDeleteOfficerGroups: (state) => {
      state.loading = true;
      state.error = null;
    },
    bulkDeleteOfficerGroupsSuccess: (state, action) => {
      state.loading = false;
      state.officerGroups = state.officerGroups.filter((og) => !action.payload.includes(og.id));
      state.error = null;
      state.successMessage = action.payload.message;
    },
    bulkDeleteOfficerGroupsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Pagination
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.page = 1;
    },

    // Sorting
    setSortColumn: (state, action) => {
      state.sortColumn = action.payload;
    },
    setSortDirection: (state, action) => {
      state.sortDirection = action.payload;
    },

    // Filtering
    setFilterName: (state, action) => {
      state.filterName = action.payload;
      state.page = 1;
    },

    // Clear messages
    clearError: (state) => {
      state.error = null;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
  },
});

export const {
  fetchOfficerGroups,
  fetchOfficerGroupsSuccess,
  fetchOfficerGroupsFailure,
  fetchOfficerGroupById,
  fetchOfficerGroupByIdSuccess,
  fetchOfficerGroupByIdFailure,
  addOfficerGroup,
  addOfficerGroupSuccess,
  addOfficerGroupFailure,
  updateOfficerGroup,
  updateOfficerGroupSuccess,
  updateOfficerGroupFailure,
  deleteOfficerGroup,
  deleteOfficerGroupSuccess,
  deleteOfficerGroupFailure,
  bulkDeleteOfficerGroups,
  bulkDeleteOfficerGroupsSuccess,
  bulkDeleteOfficerGroupsFailure,
  setPage,
  setPageSize,
  setSortColumn,
  setSortDirection,
  setFilterName,
  clearError,
  clearSuccessMessage,
} = officerGroupsSlice.actions;

// Selectors
export const selectOfficerGroups = (state) => state.officerGroups?.officerGroups || [];
export const selectSelectedOfficerGroup = (state) => state.officerGroups?.selectedOfficerGroup;
export const selectOfficerGroupsLoading = (state) => state.officerGroups?.loading || false;
export const selectOfficerGroupsError = (state) => state.officerGroups?.error;
export const selectOfficerGroupsSuccessMessage = (state) => state.officerGroups?.successMessage;
export const selectOfficerGroupsTotal = (state) => state.officerGroups?.total || 0;
export const selectOfficerGroupsPage = (state) => state.officerGroups?.page || 1;
export const selectOfficerGroupsPageSize = (state) => state.officerGroups?.pageSize || 10;
export const selectOfficerGroupsSortColumn = (state) => state.officerGroups?.sortColumn || 'name';
export const selectOfficerGroupsSortDirection = (state) => state.officerGroups?.sortDirection || 'asc';
export const selectOfficerGroupsFilterName = (state) => state.officerGroups?.filterName || '';

export default officerGroupsSlice.reducer;

